'use client';

import Button from '@/components/common/Button';
import CardStep from '@/components/CardStep';
import InfiniteCarousel from '@/components/InfiniteCarousel';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import CookieConsent, { Cookies, getCookieConsentValue } from 'react-cookie-consent';
import { FaArrowRight, FaCloudArrowDown, FaCoins, FaFileCircleCheck, FaHandshake, FaHouse, FaPen, FaShield, FaShieldHalved, FaShop, FaTableList, FaX, FaXmark } from 'react-icons/fa6';

import desktopImageFONDO from '@/assets/images/desktop/studente-concentrato-che-legge.webp'
import desktopImageFORM from '@/assets/images/desktop/studentessa-che-studia-al-computer.webp'
import desktopImageLINGUE from '@/assets/images/desktop/gruppo-di-studio-esame-di-grammatica.webp'
import desktopImageMAGISTRALE from '@/assets/images/desktop/studenti-in-aula-durante-lezione.webp'
import desktopImageMASTER from '@/assets/images/desktop/laureati-celebrano-laurea.webp'
import desktopImagePHD from '@/assets/images/desktop/studentessa-in-citta-con-libri-e-cuffie.webp'
import desktopImageRESTITUZIONE from '@/assets/images/desktop/consulente-mostra-informazioni-su-smartphone.webp'
import desktopImageSPECIALIZZAZIONE from '@/assets/images/desktop/uniforme-medica-con-stetoscopio.webp'
import desktopImageTRIENNALE from '@/assets/images/desktop/laureata-con-corona-di-alloro.webp'

import loghiImageUnicreditWhite from '@/assets/images/loghi/Unicredit_logo_white.svg'
import loghiImageLogoHabacusBiancoCROPPED from '@/assets/images/loghi/Habacus_logo_white.svg'
import loghiImageLogoHabacusBluCROPPED from '@/assets/images/loghi/Habacus_logo.svg'
import appHabacus from '@/assets/images/loghi/App_Habacus_2_0.webp'
import shopButtonGoogle from '@/assets/images/loghi/Download_playstore.svg'
import shopButtonApple from '@/assets/images/loghi/Download_appstore.svg'

import mobileImageFONDO from '@/assets/images/mobile/studente-concentrato-che-legge.webp'
import mobileImageRESTITUZIONE from '@/assets/images/mobile/consulente-mostra-informazioni-su-smartphone.webp'
import SectionHeader from '@/components/SectionHeader';
import QRCodeStyling, { Options } from 'qr-code-styling';
import Modal from 'react-modal';



const Landing = () => {

    const formRef = useRef<HTMLDivElement | null>(null);

    const [deviceType, setDeviceType] = useState("Other");

    const googleCanvasRef = useRef<HTMLDivElement | null>(null);
    const appleCanvasRef = useRef<HTMLDivElement | null>(null);

    const [cookieStatus, setCookieStatus] = useState<string | undefined>(undefined);

    useEffect(() => {
        let userAgent = "other";
        if (typeof window !== "undefined") {
            userAgent = navigator.userAgent;
        }

        if (/android/i.test(userAgent)) {
            setDeviceType("Android");
        } else if (/iPad|iPhone|iPod/.test(userAgent)) {
            setDeviceType("Apple");
        }

        const myCookieConsent = getCookieConsentValue('myCookieConsent');
        setCookieStatus(myCookieConsent);

    }, []);

    const handleAcceptAll = () => {
        // Custom logic to close the popup
        Cookies.set("myCookieConsent", "all", { expires: 365 });
        setCookieStatus("all");
    };

    const handleCookieDeclined = () => {
        Cookies.set("myCookieConsent", "necessary", { expires: 365 });
        setCookieStatus("necessary");
    };

    const scrollToSection = (ref: React.RefObject<HTMLDivElement | null>) => {
        ref?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };


    const renderSection1 = () => {
        // jumbotron con immagine 
        return <div
            className="mx-5 lg:mx-10 mb-20 lg:mb-40 px-12 lg:px-32
            relative
                min-h-[36rem] lg:min-h-[54rem] 
                flex justify-center flex-col 
            "
        >
            <Image src={desktopImageFONDO} alt="Giovane studente con occhiali concentrato nella lettura di un libro, seduto vicino a una finestra illuminata dalla luce naturale." className="hidden lg:block rounded-cornerDesk" style={{ objectFit: "cover" }} sizes="100%" fill priority />
            <Image src={mobileImageFONDO} alt="Giovane studente con occhiali concentrato nella lettura di un libro, seduto vicino a una finestra illuminata dalla luce naturale." className="lg:hidden rounded-cornerMob" sizes="100%" style={{ objectFit: "cover" }} fill priority />
            <div className="absolute inset-0 bg-gradient-to-r from-[rgba(0,0,0,0.9)] via-[rgba(0,0,0,0.5) to-transparent opacity-100 rounded-cornerMob lg:rounded-cornerDesk"></div>

            <div className='z-10 w-3/4 lg:w-1/2'>

                <h1 className='text-white mb-5'>
                    Fondo per lo studio: accedi al credito per  il tuo futuro con
                </h1>
                <Image src={loghiImageUnicreditWhite} alt="UniCredit S.p.A. Logo" height={64} className='mb-5 lg:mb-8' />
                <div className='text-white mb-5 lg:mb-8'>Ottieni il prestito per studenti grazie al <b>fondo per lo studio.</b></div>
                <Button text='Inizia qui' onClick={() => scrollToSection(formRef)} />

            </div>

        </div>
    }

    const renderSection2 = () => {
        //investi nel futuro. 
        return <div className='mb-20 lg:mb-40 '>
            <h1 className='text-center lg:mb-5'>Investi nel tuo futuro.</h1>
            <div className='text-center mb-10 lg:mb-20'>
                Scopri i corsi che puoi finanziare
            </div>
            {/* <Slider /> */}
            <div className='lg:hidden'>
                <InfiniteCarousel />
            </div>
            <div className='hidden lg:block mx-10'>
                <div className='flex mb-5 gap-5'>
                    <div className="relative h-80 w-3/12 transition-transform duration-300 ease-out hover:scale-[102%]">
                        <Image src={desktopImageMASTER} alt=" Gruppo di studenti in abiti da laurea che festeggiano all’aperto, lanciando i cappelli in aria e tenendo in mano i diplomi." className="hidden lg:block rounded-cornerDesk bg-cover" sizes="100%" fill style={{ objectFit: "cover" }} />

                        <div className="absolute inset-0 bg-gradient-to-b from-[rgba(0,0,0,0.9)] via-[rgba(0,0,0,0.2)] to-transparent opacity-100 rounded-cornerDesk z-0"></div>

                        <div className="relative z-10 p-6">
                            <h2 className="text-white">
                                Master universitario di primo o secondo livello
                            </h2>
                        </div>
                    </div>
                    <div className="relative h-80 w-7/12 flex justify-end items-center transition-transform duration-300 ease-out hover:scale-[102%]">
                        <Image src={desktopImageTRIENNALE} alt="Giovane laureata con corona di alloro in testa, simbolo della laurea in Italia, sorridente e immersa nella natura." className="hidden lg:block rounded-cornerDesk bg-cover" sizes="100%" fill style={{ objectFit: "cover" }} />

                        <div className="absolute inset-0 bg-gradient-to-l from-[rgba(0,0,0,0.9)] via-[rgba(0,0,0,0.2)] to-transparent opacity-100 rounded-cornerDesk z-0"></div>
                        <div className="relative z-10 p-6 flex justify-end">
                            <h2 className="text-white text-right w-1/2 ">
                                Corso di Laurea Triennale o Specialistica a ciclo unico
                            </h2>
                        </div>
                    </div>
                    <div className=" transition-transform duration-300 ease-out hover:scale-[102%] relative h-80 w-2/12 bg-cover flex items-end">
                        <Image src={desktopImageMAGISTRALE} alt="Studenti concentrati che prendono appunti durante una lezione in aula universitaria." className="hidden lg:block rounded-cornerDesk bg-cover" sizes="100%" fill style={{ objectFit: "cover" }} />

                        <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.9)] via-[rgba(0,0,0,0.2)] to-transparent opacity-100 rounded-cornerDesk z-0"></div>
                        <div className="relative z-10 p-6">
                            <h2 className="text-white">
                                Corso di Laurea Magistrale
                            </h2>
                        </div>
                    </div>
                </div>
                <div className='flex gap-5'>
                    <div className="transition-transform duration-300 ease-out hover:scale-[102%] relative h-80 w-5/12 flex items-end">
                        <Image src={desktopImageLINGUE} alt="Studenti riuniti attorno a un tavolo per una sessione di studio, analizzando un test di grammatica." className="hidden lg:block rounded-cornerDesk bg-cover" sizes="100%" fill style={{ objectFit: "cover" }} />

                        <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.9)] via-[rgba(0,0,0,0.2)] to-transparent opacity-100 rounded-cornerDesk z-0"></div>
                        <div className="relative z-10 p-6">
                            <h2 className="text-white">
                                Corso di lingue di almeno sei mesi, riconosciuto da un ente certificatore
                            </h2>
                        </div>
                    </div>
                    <div className="transition-transform duration-300 ease-out hover:scale-[102%] relative h-80 w-3/12 flex items-center">
                        <Image src={desktopImagePHD} alt="Giovane studentessa sorridente con cuffie e libri in mano, cammina per la città con uno sfondo urbano suggestivo." className="hidden lg:block rounded-cornerDesk bg-cover" sizes="100%" fill style={{ objectFit: "cover" }} />

                        <div className="absolute inset-0 bg-gradient-to-r from-[rgba(0,0,0,0.9)] via-[rgba(0,0,0,0.2)] to-transparent opacity-100 rounded-cornerDesk z-0"></div>
                        <div className="relative z-10 p-6">
                            <h2 className="text-white">
                                Dottorato di Ricerca triennale all&apos;estero
                            </h2>
                        </div>
                    </div>
                    <div className="transition-transform duration-300 ease-out hover:scale-[102%] relative h-80 w-4/12 flex items-end">
                        <Image src={desktopImageSPECIALIZZAZIONE} alt="Primo piano di un camice medico azzurro con stetoscopio riposto nella tasca." className="hidden lg:block rounded-cornerDesk bg-cover" sizes="100%" fill style={{ objectFit: "cover" }} />

                        <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.9)] via-[rgba(0,0,0,0.2)] to-transparent opacity-100 rounded-cornerDesk z-0"></div>
                        <div className="relative z-10 p-6">
                            <h2 className="text-white">
                                Corso di specializzazione post-laurea in Medicina e Chirurgia a ciclo unico
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className='text-center mt-10 lg:mt-20'>
                <Button onClick={() => scrollToSection(formRef)} text='Finanzia il corso' />
            </div>
        </div>
    }

    const [openAccordion, setOpenAccordion] = useState<number | null>(null);
    const renderSection3 = () => {

        const accordionData = [
            {
                title: 'Età',
                text: "L'età del richiedente deve essere compresa tra i 18 e i 40 anni al momento della domanda."
            },
            {
                title: 'Iscrizione',
                text: 'È necessario essere regolarmente iscritti presso un ente formativo riconosciuto.'
            },
            {
                title: 'Titolo di studio e voto di laurea',
                text: "Per chi si iscrive a lauree triennali o magistrali a ciclo unico, è richiesto un voto di diploma pari o superiore a 75/100. Per l'accesso a lauree magistrali, corsi di specializzazione in medicina e chirurgia o master universitari di primo e secondo livello, è richiesto un voto di laurea pari o superiore a 100/110. É inoltre necessario essere in regola con il pagamento delle tasse universitarie."
            },
            {
                title: 'Residenza',
                text: 'Per richiedere il prestito, è necessario avere la residenza in Italia.'
            }
        ]
        const toggleAccordion = (index: number) => {
            if (openAccordion === index) {
                setOpenAccordion(null); // Chiude se già aperto
            } else {
                setOpenAccordion(index); // Apre il nuovo accordion
            }
        };

        return <div className='mx-5 lg:mx-40 flex flex-col lg:flex-row lg:justify-between mb-20 lg:mb-40 '>
            <div className='text-center lg:text-left mb-5'>
                <h1 className='lg:mb-5'>I requisiti</h1>
                <div>Chi può accedere al</div>
                <div className='font-bold'>Fondo per lo Studio?</div>
            </div>
            <div className='w-full lg:w-8/12'>
                {accordionData.map((item, index) => (
                    <div key={index} className="mb-2">
                        <button
                            onClick={() => toggleAccordion(index)}
                            className="bg-blueDark text-white px-5 py-2 lg:py-5 w-full text-left flex justify-between"
                        >
                            <span>{item.title}</span> <span>{openAccordion === index ? '-' : '+'}</span>
                        </button>
                        {openAccordion === index && (
                            <div className="px-5 py-2 lg:py-5 lg:mb-8 bg-grayLight rounded-cornerMob lg:rounded-cornerDesk">
                                {item.text}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    }

    const renderSection4 = () => {
        //come funziona
        return <div className='mx-5 lg:mx-40 mb-20 lg:mb-40 '>
            <div className='text-center mb-10 lg:mb-20'>
                <h1 className='lg:mb-5'>Come funziona</h1>
                <div>Scopri le condizioni del prestito per il tuo percorso di studi</div>
            </div>
            <div className='flex gap-10 flex-col lg:flex-row'>
                <div className='bg-grayLight rounded-cornerMob lg:rounded-cornerDesk grid grid-cols-12 py-8 px-12'>
                    <div className='col-span-12'> <FaCoins className='text-grayDark' size={'3rem'} /></div>
                    <h2 className='col-span-12 mb-3'>Somma richiedibile</h2>
                    <div className='col-span-12'>Richiedi fino a 5.000 euro per ogni anno di studi, con un massimo totale di 25.000 euro.</div>
                </div>
                <div className='bg-grayLight rounded-cornerMob lg:rounded-cornerDesk grid grid-cols-12 py-8 px-12'>
                    <div className='col-span-12'> <FaHandshake className='text-grayDark' size={'3rem'} /></div>
                    <h2 className='col-span-12 mb-3'>Garanzie necessarie</h2>
                    <div className='col-span-12'>Nessuna garanzia aggiuntiva è richiesta. Non servono né busta paga né firma di un genitore: la garanzia è fornita dallo Fondo per lo Studio.</div>
                </div>
                <div className='bg-grayLight rounded-cornerMob lg:rounded-cornerDesk grid grid-cols-12 py-8 px-12'>
                    <div className='col-span-12'> <FaFileCircleCheck className='text-grayDark' size={'3rem'} /></div>
                    <h2 className='col-span-12 mb-3'>Certificato iscrizione</h2>
                    <div className='col-span-12'>Per ricevere le rate annuali, basta presentare il certificato di iscrizione e aver superato almeno il 50% degli esami dell&apos;anno precedente.</div>
                </div>


            </div>

            <div className='text-center mt-10 lg:mt-20'>
                <Button onClick={() => scrollToSection(formRef)} text='Scopri di più' />
            </div>


        </div>
    }

    const renderSection5 = () => {
        // restituzione flessibile
        return <div className='mx-5 lg:mx-40 mb-20 lg:mb-40 '>
            <div className='text-center mb-10 lg:mb-20'>
                <h1 className='lg:mb-5'>La restituzione flessibile</h1>
                <div>Come e quando restituire il prestito</div>
            </div>
            <div className='grid grid-cols-2 gap-8'>
                <div className='col-span-2 lg:col-span-1'>
                    <Image src={mobileImageRESTITUZIONE} alt="Professionista sorridente che mostra informazioni sullo smartphone a un’altra persona durante una consulenza." className='rounded-cornerMob lg:hidden' />
                    <Image src={desktopImageRESTITUZIONE} alt="Professionista sorridente che mostra informazioni sullo smartphone a un’altra persona durante una consulenza." className='rounded-cornerDesk hidden lg:block' />
                </div>
                <div className='col-span-2 lg:col-span-1 lg:flex lg:flex-col lg:justify-center'>

                    <div className='mb-8'>
                        <div className='mb-3 lg:w-10/12 2xl:w-1/2'>
                            <h2 className='bg-grayLight py-2 px-5 rounded-cornerMob'>Restituzione del prestito</h2>
                        </div>
                        <div>
                            Puoi <b>iniziare a restituire</b> il finanziamento a partire dal <b>30&deg; mese successivo all&apos;erogazione dell&apos;ultima rata</b>.
                        </div>
                    </div>
                    <div className='mb-8'>
                        <div className='mb-3 lg:w-10/12 2xl:w-1/2'>
                            <h2 className='bg-grayLight py-2 px-5 rounded-cornerMob'>Restituisci a rate</h2>
                        </div>
                        <div>
                            Con UniCredit S.p.A. puoi <b>restituire il prestito fino a 3 anni</b>.
                        </div>
                    </div>
                    <div className=''>
                        <div className='mb-3 lg:w-10/12 2xl:w-1/2'>
                            <h2 className='bg-grayLight py-2 px-5 rounded-cornerMob'>In caso di difficoltà</h2>
                        </div>
                        <div>
                            Il Fondo copre <b>fino al 70% dell&apos;importo</b> del prestito studentesco concesso.
                        </div>
                    </div>
                </div>
            </div>

        </div>
    }
    const [currentStep, setCurrentStep] = useState(0);
    const stepRefs = useRef<HTMLDivElement[]>([]);
    const [dotPositions, setDotPositions] = useState<number[]>([]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + window.innerHeight / 2;
            stepRefs.current.forEach((step, index) => {
                if (step && step.offsetTop < scrollPosition) {
                    setCurrentStep(index);
                }
            });
        };

        const updateDotPositions = () => {
            const positions = stepRefs.current.map((step) => step?.offsetTop || 0);
            setDotPositions(positions);
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', updateDotPositions);
        updateDotPositions();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', updateDotPositions);
        };
    }, []);



    let subtitle;
    const [modalIsOpen, setIsOpen] = useState(false);

    function openModal() {
        setIsOpen(true);
    }


    function closeModal() {
        setIsOpen(false);
    }

    const customStylesModal = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            background: 'rgb(4 30 104)',
            color: 'white',
            borderRadius: '20px',
            border: 'none',
            padding: '2rem',
            zIndex: 9999

        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)', // Ensure the overlay dims the background
            zIndex: 9998 // Set the overlay z-index slightly lower than modal
        },
    };

    const renderSection6 = () => {
        //I passi per richiedere il finanziamento
        // vbersione mobile/desktop

        // const cards = [
        //     {
        //         icon: <FaTableList className='text-grayDark' size={'2rem'} />,
        //         title: 'Compila il form',
        //         text: 'Inserisci i tuoi dati personali per iscriverti e avviare la procedura.',
        //         button: 'Vai al form',
        //         onScrollToForm: () => scrollToSection(formRef),
        //     },
        //     {
        //         icon: <FaCloudArrowDown className='text-grayDark' size={'2rem'} />,
        //         title: 'Scarica l\'app Habacus',
        //         text: 'Dopo aver effettuato l\'iscrizione, scarica l\'app Habacus e inizia il processo di certificazione direttamente dal tuo smartphone.',
        //     },
        //     {
        //         icon: <FaShieldHalved className='text-grayDark' size={'2rem'} />,
        //         title: 'Certifica i tuoi requisiti',
        //         text: 'Carica i documenti necessari e completa il percorso di certificazione seguendo i vari passaggi.',
        //     },
        //     {
        //         icon: <FaPen className='text-grayDark' size={'2rem'} />,
        //         title: 'Firma il modulo di accesso al fondo',
        //         text: 'Una volta certificato, firma il modulo per richiedere l\'accesso ufficiale al Fondo per lo Studio.',
        //     },
        //     {
        //         icon: <FaShop className='text-grayDark' size={'2rem'} />,
        //         title: 'Vai in filiale per richiedere l\'erogazione',
        //         text: 'Recati presso una filiale UniCredit S.p.A. per completare la richiesta e ottenere l\'erogazione del finanziamento.',
        //     },
        // ];



        return <div className='mx-5 lg:mx-40 mb-20 lg:mb-40 '>
            <div className='text-center mb-10 lg:mb-20'>
                <h1 className='lg:mb-5'>I passi per richiedere il <br /> finanziamento</h1>
                <div>Segui queste semplici fasi per accedere al Fondo per lo Studio</div>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStylesModal}
                contentLabel="Example Modal"
                ariaHideApp={false}
            >
                <header className='flex justify-end mb-5'>
                    <button onClick={closeModal}><FaXmark /></button>
                </header>
                <div className='lg:pl-20 lg:pr-20'>
                    <h2 className='mb-5'>Di seguito l&apos;elenco degli enti in perimetro <br /> per la richiesta del prestito:</h2>
                    <ul className='list-disc pl-5 overflow-y-auto'>
                        <li className='mb-2'>Accademia delle Belle Arti di Brera</li>
                        <li className='mb-2'>IED Milano</li>
                        <li className='mb-2'>Istituto Marangoni</li>
                        <li className='mb-2'>IULM Milano</li>
                        <li className='mb-2'>NABA Milano</li>
                        <li className='mb-2'>Politecnico di Milano</li>
                        <li className='mb-2'>Politecnico di Torino</li>
                        <li className='mb-2'>Università Cattolica del Sacro Cuore</li>
                        <li className='mb-2'>Università degli Studi di Milano</li>
                        <li className='mb-2'>Università degli Studi di Milano - Bicocca</li>
                        <li className='mb-2'>Università degli Studi di Torino</li>
                        <li className='mb-2'>Università Vita-Salute San Raffaele</li>
                    </ul>
                </div>

            </Modal>
            {/* MOBILE */}
            <div className='lg:hidden '>

                <ul className='step-list'>
                    <li className='step-item'>
                        <div className="step-content pb-10 w-full">
                            <div className='bg-grayLight py-10 px-5 rounded-cornerMob'>

                                <div className='flex justify-between flex-row-reverse lg:flex-col mb-3'>
                                    <div className='w-2/12 flex justify-end lg:justify-normal lg:mb-3'>
                                        <FaTableList className='text-grayDark' size={'2rem'} />
                                    </div>
                                    <h2 className='w-10/12 flex items-end'>Verifica l&apos;università</h2>
                                </div>
                                <div>Controlla se il tuo ateneo rientra nel perimetro.</div>
                                <button className='buttonH2 mt-5' onClick={openModal}>Consulta l&apos;elenco</button>
                            </div>
                        </div>
                    </li>
                    <li className='step-item'>
                        <div className="step-content  pb-10 w-full">
                            <div className='bg-grayLight py-10 px-5 rounded-cornerMob'>

                                <div className='flex justify-between flex-row-reverse lg:flex-col mb-3'>
                                    <div className='w-2/12 flex justify-end lg:justify-normal lg:mb-3'>
                                        <FaCloudArrowDown className='text-grayDark' size={'2rem'} />
                                    </div>
                                    <h2 className='w-10/12 flex items-end'>Scarica l&apos;app Habacus o vai in filiale</h2>
                                </div>
                                <div>Scarica l&apos;app Habacus per avviare la certificazione direttamente dal tuo smartphone oppure recati in una filiale di UniCredit S.p.A.</div>
                            </div>
                        </div>
                    </li>
                    <li className='step-item'>
                        <div className="step-content pb-10  w-full">
                            <div className='bg-grayLight py-10 px-5 rounded-cornerMob'>

                                <div className='flex justify-between flex-row-reverse lg:flex-col mb-3'>
                                    <div className='w-2/12 flex justify-end lg:justify-normal lg:mb-3'>
                                        <FaShieldHalved className='text-grayDark' size={'2rem'} />
                                    </div>
                                    <h2 className='w-10/12 flex items-end'>Certifica i tuoi requisiti</h2>
                                </div>
                                <div>Carica i documenti necessari e completa il percorso di certificazione seguendo i vari passaggi.</div>
                            </div>
                        </div>
                    </li>
                    <li className='step-item'>
                        <div className="step-content pb-10   w-full">
                            <div className='bg-grayLight py-10 px-5 rounded-cornerMob'>
                                <div className='flex justify-between flex-row-reverse lg:flex-col mb-3'>
                                    <div className='w-2/12 flex justify-end lg:justify-normal lg:mb-3'>
                                        <FaPen className='text-grayDark' size={'2rem'} />
                                    </div>
                                    <h2 className='w-10/12 flex items-end'>Firma il modulo di accesso al fondo</h2>
                                </div>
                                <div>Una volta certificato, firma il modulo per richiedere l&apos;accesso ufficiale al Fondo per lo Studio.</div>
                            </div>
                        </div>
                    </li>
                    <li className='step-item'>
                        <div className="step-content pb-10 w-full">
                            <div className='bg-grayLight py-10 px-5 rounded-cornerMob'>

                                <div className='flex justify-between flex-row-reverse lg:flex-col mb-3'>
                                    <div className='w-2/12 flex justify-end lg:justify-normal lg:mb-3'>
                                        <FaShop className='text-grayDark' size={'2rem'} />
                                    </div>
                                    <h2 className='w-10/12 flex items-end'>Vai in filiale per richiedere l&apos;erogazione</h2>
                                </div>
                                <div>Recati presso una filiale di UniCredit S.p.A. per completare la richiesta e ottenere l&apos;erogazione del finanziamento.</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            {/* DESKTOP */}
            <div className='hidden lg:block'>
                <div>
                    <div className='grid grid-cols-12'>
                        <div className='col-span-5'></div>
                        <div className='col-span-2 flex justify-center'>

                            <div className='relative h-full w-3 bg-blueLight rounded-t-cornerMob'>
                                <div className='absolute left-1/2 transform -translate-x-1/2 top-1/4 -translate-y-1/2 w-5 h-5 bg-blueLight rounded-full '></div>
                            </div>

                        </div>
                        <div className='col-span-5'>
                            <CardStep
                                icon={<FaTableList className='text-grayDark' size={'2rem'} />}
                                title='Verifica l&apos;università'
                                text='Controlla se il tuo ateneo rientra nel perimetro.'
                                button='Consulta l&apos;elenco'
                                onClick={openModal}
                                className=""
                            />
                        </div>
                    </div>
                    <div className='grid grid-cols-12'>
                        <div className='col-span-5'>
                            <CardStep
                                icon={<FaCloudArrowDown className='text-grayDark' size={'2rem'} />}
                                title='Scarica l&apos;app Habacus o vai in filiale'
                                text='Scarica l&apos;app Habacus per avviare la certificazione direttamente dal tuo smartphone oppure recati in una filiale di UniCredit S.p.A.'
                            />
                        </div>
                        <div className='col-span-2 flex justify-center'>
                            <div className='relative h-full w-3 bg-blueLight'>
                                {/* Centered Dot */}
                                <div className='absolute left-1/2 transform -translate-x-1/2 top-1/4 -translate-y-1/2 w-5 h-5 bg-blueLight rounded-full'></div>
                            </div>

                        </div>
                        <div className='col-span-5'>

                        </div>
                    </div>
                    <div className='grid grid-cols-12'>
                        <div className='col-span-5'></div>
                        <div className='col-span-2 flex justify-center'>
                            <div className='relative h-full w-3 bg-blueLight'>
                                {/* Centered Dot */}
                                <div className='absolute left-1/2 transform -translate-x-1/2 top-1/4 -translate-y-1/2 w-5 h-5 bg-blueLight rounded-full'></div>
                            </div>

                        </div>
                        <div className='col-span-5'>
                            <CardStep
                                icon={<FaShieldHalved className='text-grayDark' size={'2rem'} />}
                                title='Certifica i tuoi requisiti'
                                text='Carica i documenti necessari e completa il percorso di certificazione seguendo i vari passaggi.'
                            />
                        </div>
                    </div>
                    <div className='grid grid-cols-12'>
                        <div className='col-span-5'>
                            <CardStep
                                icon={<FaPen className='text-grayDark' size={'2rem'} />}
                                title='Firma il modulo di accesso al fondo'
                                text='Una volta certificato, firma il modulo per richiedere l&apos;accesso ufficiale al Fondo per lo Studio.'
                            />
                        </div>
                        <div className='col-span-2 flex justify-center'>
                            <div className='relative h-full w-3 bg-blueLight'>
                                {/* Centered Dot */}
                                <div className='absolute left-1/2 transform -translate-x-1/2 top-1/4 -translate-y-1/2 w-5 h-5 bg-blueLight rounded-full'></div>
                            </div>
                        </div>
                        <div className='col-span-5'>

                        </div>
                    </div>

                    <div className='grid grid-cols-12'>
                        <div className='col-span-5'></div>
                        <div className='col-span-2 flex justify-center'>
                            <div className='relative h-full w-3 bg-blueLight rounded-b-cornerDesk'>
                                {/* Centered Dot */}
                                <div className='absolute left-1/2 transform -translate-x-1/2 top-1/4 -translate-y-1/2 w-5 h-5 bg-blueLight rounded-full'></div>
                            </div>
                        </div>
                        <div className='col-span-5'>
                            <CardStep
                                icon={<FaShop className='text-grayDark' size={'2rem'} />}
                                title='Vai in filiale per richiedere l&apos;erogazione'
                                text='Recati presso una filiale di UniCredit S.p.A. per completare la richiesta e ottenere l&apos;erogazione del finanziamento.'
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex justify-center mt-10 lg:mt-20'>
                <Button
                    text="Richiedi"
                    onClick={() => scrollToSection(formRef)}
                />
            </div>
        </div>
    }

    const playStoreLink = "https://play.google.com/store/apps/details?id=com.habacus.mobile&utm_source=habacus&utm_medium=landing_ucg"
    const appStoreLink = "https://apps.apple.com/it/app/habacus/id1605794488?&utm_source=habacus&utm_medium=landing_ucg"

    const createQrCode = (link: string): Partial<Options> => {
        return {
            type: "svg",
            shape: "square",
            width: 180,
            height: 180,
            data: link,
            margin: 0,
            qrOptions: {
                typeNumber: 0,
                mode: "Byte",
                errorCorrectionLevel: "Q"
            },
            dotsOptions: {
                type: "dots",
                color: "#041e68",
                roundSize: true,
                gradient: undefined
            },
            backgroundOptions: {
                round: 0,
                color: "rgb(226 232 247)"
            },
            cornersSquareOptions: {
                type: "extra-rounded",
                color: "#041e68"
            },
            cornersDotOptions: {
                type: undefined,
                color: "#041e68"
            },
            imageOptions: {
                imageSize: 100
            }
        }
    }

    useEffect(() => {
        if (googleCanvasRef.current && appleCanvasRef.current) {
            const googleQRCode = new QRCodeStyling(createQrCode(playStoreLink));
            googleQRCode.append(googleCanvasRef.current);
        }

        if (appleCanvasRef.current) {
            const appleQRCode = new QRCodeStyling(createQrCode(appStoreLink));
            appleQRCode.append(appleCanvasRef.current);
        }
    }, []);

    const renderSection7 = () => {
        // form
        return <div ref={formRef} className="px-5 lg:px-40 pt-20 lg:pt-40 bg-grayLight rounded-t-[4rem] lg:rounded-t-[8rem]">

            <div className="grid grid-cols-12">
                <div className="col-span-12 lg:col-span-6">
                    <h1 className='mb-10 text-center lg:text-left'>Scarica L&apos;App di Habacus</h1>
                    <div className='mb-10 text-center lg:text-left'>
                        Troverai un ambiente protetto e digitale che ti permetterà di richiedere la certificazione del merito accademico con l&apos;obiettivo di facilitare l&apos;accesso al prestito studentesco con garanzia Consap di UniCredit S.p.A. per finanziare i tuoi studi.
                    </div>
                    <h3 className='font-bold mb-10 text-center lg:text-left'>INQUADRA IL QR CODE <br /> PER ACCEDERE ALLO STORE</h3>
                    <div className="grid grid-cols-12 gap-8 w-full lg:hidden">
                        {deviceType !== 'Apple' ? (
                            <div className="col-span-12 flex justify-center">
                                <div className='w-2/3'>
                                    <a href="https://play.google.com/store/apps/details?id=com.habacus.mobile" target="_blank" rel="noopener noreferrer">
                                        <Image src={shopButtonGoogle} style={{ width: '100%' }} alt="shopButtonGoogle" />
                                    </a>
                                </div>
                            </div>
                        ) : (
                            <div className="col-span-12 flex justify-center">
                                <div className='w-2/3'>
                                    <a href="https://apps.apple.com/it/app/habacus/id1605794488" target="_blank" rel="noopener noreferrer">
                                        <Image src={shopButtonApple} style={{ width: '100%' }} alt="shopButtonApple" />
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className=" grid-cols-12 gap-8 w-full hidden lg:grid mb-10">
                        <div className="col-span-6">
                            <a href="https://play.google.com/store/apps/details?id=com.habacus.mobile" target="_blank" rel="noopener noreferrer">
                                <Image src={shopButtonGoogle} style={{ width: '100%' }} alt="shopButtonGoogle" />
                            </a>
                            <div ref={googleCanvasRef} className='flex justify-center mt-5'></div>
                        </div>
                        <div className="col-span-6">
                            <a href="https://apps.apple.com/it/app/habacus/id1605794488" target="_blank" rel="noopener noreferrer">
                                <Image src={shopButtonApple} style={{ width: '100%' }} alt="shopButtonApple" />
                            </a>
                            <div ref={appleCanvasRef} className='flex justify-center mt-5'></div>
                        </div>
                    </div>
                </div>
                <div className="col-span-12 lg:col-span-6 flex items-end justify-center pt-10 lg:pt-0 ">
                    <Image src={appHabacus} className="lg:ml-40" style={{ width: '75%' }} alt='app habacus' />
                </div>
            </div>




        </div >

    }

    const renderSection8 = () => {
        // richiesta info
        return <div className="mx-5 lg:mx-40 my-20 lg:my-40 ">

            <h1 className="mb-5 text-center lg:text-left">Hai bisogno d&apos;informazioni?</h1>

            <a href='mailto:info@habacus.com?subject=Info%20prestito%20studentesco%20UniCredit&body=Ciao%2C%20vorrei%20pi%C3%B9%20informazioni%20sul%20prestito%20studentesco%20di%20UniCredit' target="_blank" className='mb-10 flex justify-between items-center  bg-grayLight py-3 px-8 rounded-cornerMob lg:w-1/2'>
                <span>Scrivici via e-mail</span> <FaArrowRight />
            </a>
            <a href='https://wa.me/+393488206605?text=Ciao%2C%20vorrei%20pi%C3%B9%20informazioni%20sul%20prestito%20studentesco%20di%20UniCredit' target="_blank" className='mb-10 flex justify-between items-center  bg-grayLight py-3 px-8 rounded-cornerMob lg:w-1/2'>
                <span>Scrivici su Whatsapp</span> <FaArrowRight />
            </a>

        </div>
    }
    const renderSection9 = () => {
        // footer
        return <div className="px-5 lg:px-40 py-20 lg:py-40 bg-blueDark text-white">
            <div className="flex h-full items-center space-x-5 lg:space-x-10 mb-5">
                <div className="h-full flex items-center justify-center">
                    <Image src={loghiImageLogoHabacusBiancoCROPPED} alt="Habacus logo" height={32} />
                </div>

                <div className="h-full flex items-center pl-5 lg:pl-10  border-l border-white">
                    <Image src={loghiImageUnicreditWhite} alt="UniCredit S.p.A. logo" height={32} />
                </div>
            </div>
            <div className='smallerText mb-3 mt-10'>
                Messaggio pubblicitario con finalità promozionale.
            </div>
            <div className='smallerText mb-3'>
                Per le condizioni contrattuali dei prodotti offerti consultare il relativo Modulo Informazioni Europee di Base sul Credito ai Consumatori, disponibile in fase di richiesta e/o il relativo Foglio Informativo, disponibile sul sito UniCredit.it, sezione <a href="https://www.unicredit.it/it/info/trasparenzabancaria/trasparenza/trasparenzaprivati.html" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Trasparenza</a>.
            </div>
            <div className='smallerText mb-3'>
                Prodotti venduti da UniCredit S.p.A. che si riserva la valutazione del merito creditizio per la concessione dei finanziamenti.
            </div>
            <div className='smallerText mb-3 mt-10'>
                Habacus srl - Sede legale: Via Cappuccio, 14, 20123 Milano (MI), Italia. C.F. e numero di iscrizione presso il Registro delle Imprese di Milano Monza Brianza Lodi 04906910262
            </div>
            <div className='smallerText'>
                Habacus srl &copy; 2025
            </div>
        </div >
    }

    return (
        <>
            <SectionHeader image={loghiImageLogoHabacusBluCROPPED} />
            {renderSection1()}
            {renderSection2()}
            {renderSection3()}
            {renderSection4()}
            {renderSection5()}
            {renderSection6()}
            {renderSection7()}
            {renderSection8()}
            {renderSection9()}


            {cookieStatus !== undefined ? null :
                <CookieConsent
                    // debug={true} //DA RIMUOVERE PER IL DEPLOY
                    location="none"
                    cookieName="myCookieConsent"
                    disableStyles={true}
                    buttonStyle={{ display: 'none' }}
                    containerClasses="fixed top-[80%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90%] p-5 rounded-lg bg-grayLight shadow-lg z-[9999]"
                    contentClasses="text-capitalize"
                    overlay
                    overlayClasses="fixed inset-0 bg-black bg-opacity-50 z-[9998]"
                >
                    <div className='flex justify-between items-start'>
                        <p className='smallerText'>
                            Utilizziamo i cookie per offrirti la miglior esperienza possibile sul nostro sito web.<br />
                            Usa il pulsante “Accetta tutti” per acconsentire. Usa il pulsante “Rifiuta” o chiudi questo banner per continuare senza accettare.<br />
                            <a href="https://habacus.com/privacy-cookie-policy/" target="_blank" rel="noopener noreferrer" className='underline'>Informativa sulla Privacy</a>.
                        </p>

                        <button onClick={handleCookieDeclined} className='text-sm font-normal text-blueDark'>x</button>
                    </div>
                    <div className='flex gap-3 mt-4'>
                        <button
                            onClick={handleAcceptAll}
                            className="react-cookie-consent__button text-sm py-2 px-5 rounded-lg bg-blueLight font-normal " >
                            Accetta tutti
                        </button>
                        <button
                            onClick={handleCookieDeclined}
                            className="border-blueDark border text-sm py-2 px-5 rounded-lg text-blueDark font-normal " >
                            Rifiuta
                        </button>
                    </div>
                </CookieConsent>
            }
        </>
    );
};

export default Landing;
